import {Fragment} from "react";

import {kmAppLink} from "@pg-mono/km-routes";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {getFullKMLink} from "../../utils/get_full_km_link";

const kmFavoritesLink = getFullKMLink(kmAppLink.site.offers.favouritesWithParams);

export const addRealEstateToFavouritesSuccess = addSuccessNotification(
    <Fragment>
        Dodałeś ofertę do obserwowanych <br /> <br />
        <strong>
            <a href={kmFavoritesLink} target="_blank" title="Ulubione" style={{textDecoration: "underline"}}>
                Zobacz listę
            </a>
        </strong>
        <br />
    </Fragment>
);

export const removeRealEstateFromFavouritesSuccess = addSuccessNotification("Usunąłeś ofertę z obserwowanych");
